<template>
  <header class="main-header">
    <a @click="dashboard"  class="logo">
      <img src="../../public/static/logo-light.svg" alt="logo" class="logo-light" />
      <img src="../../public/static/logo-dark.svg" alt="logo" class="logo-dark" />
    </a>
    <nav class="navbar navbar-expand-sm">
      <ul class="navbar-nav mr-auto">
        <li
          class="nav-item hamburger-link"
          v-bind:class="{ shownav: showSidebar }"
          @click="toggleSidebar"
        >
          <a class="nav-link" href="#">
            <div class="hamburger">
              <span class="line"></span>
              <span class="line"></span>
              <span class="line"></span>
            </div>
          </a>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto navright-list">
        <li class="facilityseclect nav-item">
          <div class="f-selectbox">
            <!-- <facilityseclect /> -->
          </div>
        </li>
        <li class="setting nav-item">
          <!-- <router-link class="nav-link" :to="{ name: 'settings'}">
            <b-icon-gear-fill></b-icon-gear-fill>
          </router-link> -->
        </li>
        <b-nav-item-dropdown right id="Notification" class="notification header-dropdown">
          <template v-slot:button-content>
            <b-icon-bell-fill></b-icon-bell-fill>
          </template>
          <b-dropdown-item href="#">
            <b-icon-envelope-fill></b-icon-envelope-fill>
            <span>Lorem Impsum</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <!-- <b-nav-item-dropdown right id="UserProfile" class="user-info header-dropdown">
          <template v-slot:button-content>
            <img src="../assets/images/sandy.jpg" class="user-image" alt="User Image" />
            Bruce Wayne
          </template>
          <b-dropdown-item href="#">
            <b-icon-person-fill></b-icon-person-fill>Profile
          </b-dropdown-item>
          <b-dropdown-item @click="logout">
            <b-icon-power></b-icon-power>Logout
          </b-dropdown-item>
          <div class="divider-dash">
            <p class="p-menu-header">Theme</p>
            <div class="row no-gutters">
              <div class="col">
                <p class="no-margin">Dark Mode</p>
              </div>
              <div class="col text-right">
                <b-form-checkbox name="check-button" switch></b-form-checkbox>
              </div>
            </div>
          </div>
        </b-nav-item-dropdown>-->
        <li
          class="nav-item myprofile"
          v-bind:class="{ showasidebar: showAsidebar }"
          @click="toggleAsidebar"
        >
          <span>
            <img src="../assets/images/sandy.jpg" class="user-image" alt="User Image" />
          </span>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
// import facilityseclect from "../components/FacilitiesSelectbox/Facilities";
export default {
  components: {
    // facilityseclect
  },
  data() {
    return {
      showSidebar: false,
      showAsidebar: false
    };
  },
  methods: {
    toggleSidebar: function() {
      this.$root.$emit("flyoutSidebar");
      this.showSidebar = !this.showSidebar;
    },
    toggleAsidebar: function() {
      this.$root.$emit("flyoutAsidebar");
      this.showAsidebar = !this.showAsidebar;
    },
    dashboard() {
      this.$router.push("/dashboard").catch(()=>{});
    },
    logout() {
      this.$store.dispatch("login/logout");
    },
    toggleSettings() {
      // this.$router.push({ name: "settings" });
    }
  }
};
</script>

<style>
</style>